/**
 * Navigation clavier ←/→ sur les pages d'étape chronologique.
 *
 * Lit les URLs précédente/suivante depuis data-prev-url / data-next-url
 * sur le <nav class="expo-etape-nav">. Si la touche flèche correspondante
 * est pressée hors d'un champ de saisie, navigue.
 *
 * RGAA :
 * - Ne déclenche pas dans un input/textarea/contenteditable (préserve la
 *   navigation native du champ)
 * - Le lien <a rel="prev|next"> reste l'élément focusable et activable
 *   au clavier (Tab + Enter) — le raccourci est juste un bonus
 */
(function () {
  'use strict';

  function isEditing(el) {
    if (!el) return false;
    const tag = el.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
    if (el.isContentEditable) return true;
    return false;
  }

  document.addEventListener('keydown', function (e) {
    // Ignorer si l'utilisateur tape dans un champ
    if (isEditing(e.target)) return;
    // Ignorer si une touche modificateur est active (raccourcis OS)
    if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return;

    const nav = document.querySelector('.expo-etape-nav');
    if (!nav) return;

    let url = null;
    if (e.key === 'ArrowLeft')  url = nav.dataset.prevUrl;
    if (e.key === 'ArrowRight') url = nav.dataset.nextUrl;
    if (!url) return;

    e.preventDefault();
    window.location.href = url;
  });
})();
